import DownloadIcon from '@assets/images/download.svg?react'
import { FC } from 'react'
import Typography from '@/ui/components/typography'
import { AssetsExportContainer } from './AssetsExport.styles'
import { useExportAssets } from './useExportAssets'
import { TAssetsExportProps } from './AssetsExport.types'

export const AssetsExport: FC<TAssetsExportProps> = ({
    assets,
    exportScope,
    scanInProgress,
    technologies,
}) => {
    const { disabled, handleOnExportClick } = useExportAssets({
        assets,
        exportScope,
        scanInProgress,
        technologies,
    })

    return (
        <AssetsExportContainer
            data-testid="assets-export"
            disabled={disabled}
            aria-disabled={disabled}
            onClick={!disabled ? handleOnExportClick : undefined}
        >
            <DownloadIcon />
            <Typography variant="s-regular" className="download-text">
                Download Report
            </Typography>
        </AssetsExportContainer>
    )
}
